import React from "react";
import Quality from "./Quality";

// Thin screen file — all logic lives in Quality.js; scope picks which rows show.
function StoreCheck() {
  return <Quality scope="STORE" />;
}

export default StoreCheck;